import Component from './Categories.container';

export default Component;
